import React, {Component} from "react";
import ReactDOM from "react-dom";
import App from "../../index.js";
import "../../../alfa.css"
import { config } from "../../../configs/alfa"
import loaderSvg from "../../../images/alfa-loading.svg";

const brand =  {
    value: "alfa",
    id: 7,
    division : "7",
    name : "Alfa Romeo",
    website : "https://www.alfaromeo.com.au",

};

function AlfaApp(props){
    return (
        <App brand={brand} formName={"fca-alfa-cu"} config={config} loader={loaderSvg}/>
    )
}

ReactDOM.render(<AlfaApp/>,document.getElementById("root"));
